import {
  AppointmentMapperImpl,
  ChatMapperImpl,
  CouponMapperImpl,
  NotificationMapperImpl,
  PartnershipMapperImpl,
  PaymentMapperImpl,
  ScheduleMapperImpl,
  UserMapperImpl,
} from "@phurshell/psiapp-frontend-core/data";
import { useSessionStore } from "@/store/useSessionStore";
import { cpfFormatter, stringFormatter } from "./formatters";

export const userMapper = new UserMapperImpl();
export const appointmentMapper = new AppointmentMapperImpl(
  stringFormatter,
  cpfFormatter,
  userMapper,
  () => useSessionStore().session?.id,
);
export const chatMapper = new ChatMapperImpl();
export const paymentMapper = new PaymentMapperImpl();
export const scheduleMapper = new ScheduleMapperImpl();
export const notificationMapper = new NotificationMapperImpl();
export const couponMapper = new CouponMapperImpl();
// exclusivo do paciente
export const partnershipMapper = new PartnershipMapperImpl();
